import { alertasPrioritariosVistoria } from "@/mocks/vistorias";

export default function InspectionPriorityCard() {
  const nivelConfig: Record<string, { bar: string; bg: string }> = {
    critico: { bar: "bg-danger-500", bg: "bg-danger-50" },
    alto: { bar: "bg-warning-500", bg: "bg-warning-50" },
    medio: { bar: "bg-caution-500", bg: "bg-caution-50" },
  };

  return (
    <div className="bg-white rounded-xl border border-background-200/70 overflow-hidden">
      <div className="px-5 py-3.5 border-b border-background-100 flex items-center gap-2.5">
        <span className="w-8 h-8 rounded-lg bg-danger-50 flex items-center justify-center">
          <i className="ri-alert-line text-danger-500"></i>
        </span>
        <span className="text-sm font-semibold text-foreground-900 font-heading">Vistorias Prioritárias</span>
        <span className="badge bg-danger-100 text-danger-700 ml-auto">{alertasPrioritariosVistoria.filter(a => a.nivel === "critico").reduce((s, a) => s + a.quantidade, 0) + alertasPrioritariosVistoria.filter(a => a.nivel === "alto").reduce((s, a) => s + a.quantidade, 0)} itens</span>
      </div>
      <div className="divide-y divide-background-100">
        {alertasPrioritariosVistoria.map((alerta) => {
          const nc = nivelConfig[alerta.nivel] || nivelConfig.medio;
          return (
            <div key={alerta.id} className="px-5 py-3 hover:bg-background-50/60 transition-colors cursor-pointer flex items-start gap-3">
              <div className={`w-1.5 h-1.5 rounded-full mt-1.5 shrink-0 ${nc.bar}`}></div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-0.5">
                  <i className={`${alerta.icone} text-xs text-foreground-500`}></i>
                  <h4 className="text-sm font-medium text-foreground-900 truncate">{alerta.titulo}</h4>
                </div>
                <p className="text-xs text-foreground-500 leading-relaxed">{alerta.descricao}</p>
              </div>
              <span className={`shrink-0 text-xs font-bold px-2 py-0.5 rounded-full ${nc.bg} ${alerta.nivel === "critico" ? "text-danger-700" : alerta.nivel === "alto" ? "text-warning-700" : "text-caution-700"}`}>
                {alerta.quantidade}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}